import { React } from 'react'
import { observer } from 'mobx-react'
import Dropdown from '../../ui/Dropdown/Dropdown'
import { Box, Flex } from '@chakra-ui/react'
import rootStore from '../../../store/RootStore'

const ChartFilters = observer(({ filters = [] }) => {
  const {
    chartStore: { loadingChart },
    reportStore: { setFilterOptionsSelected, filterOptionsSelected }
  } = rootStore

  const handleFilterChange = (filterName, option) => {
    setFilterOptionsSelected({ filterName, option })
  }

  return (
    <Flex
      flexWrap="wrap"
      data-testid="chart-filters">
      {loadingChart && <Box>Loading...</Box>}
      {filters?.map(filter => (
        <Dropdown
          key={filter.id}
          onChange={option => { handleFilterChange(filter.name, option) }}
          items={filter.options.map(option => ({
            id: `${option.value}`,
            value: option.value,
            label: option.text,
          }))}
          selected={filterOptionsSelected.get(filter.name)}
          shouldUsePortal
        />
      ))}
    </Flex>
  )
})

ChartFilters.propTypes = {}

export default ChartFilters
